import angular from 'angular';
import { IFolhaPonto } from '../../../models/folhaponto.model';
import { FolhasdePontoService } from '../../folhasdeponto.service';

export class FolhasPontoVisualizarpdfModalController {
    static $inject = [
        '$uibModalInstance',
        '$scope',
        '$sce',
        'entity',
        'FolhasdePontoService'
    ];

    public busy = true;
    public fileURL = '';

    constructor(
        public $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        public $scope: angular.IScope,
        public $sce: angular.ISCEService,
        public entity: IFolhaPonto,
        public FolhasdePontoService: FolhasdePontoService,
    ) {
        FolhasdePontoService.visualizarPdf(entity);
        $scope.$on('ponto_apuracoesfolhas_get_pdf_iniciado', (event, args) => {
            this.busy = false;
            const file = new Blob([args.data], { type: 'application/pdf' });
            this.fileURL = URL.createObjectURL(file);
            this.fileURL = this.trustUrl(this.fileURL);
        });
    }

    close() {
        this.$uibModalInstance.close();
    }

    trustUrl(url: string) {
        return this.$sce.trustAsResourceUrl(url);
    }
}
